import { Size } from '@anm/data/video-templates/aspect-dropdown';
import { flexCenter, flexRow, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { ItemProps } from './types';
import DropdownContent from '@anm/components/Dropdown/Content';

export const FormatIcon = styled.div<Size>`
  ${flexCenter};
  font-size: 12px;
  border-radius: 3px;
  background: #ebeef5;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

const iconBoxOnMobile = media.phone`
  margin: 0;
`;

export const IconBox = styled.div`
  ${flexCenter};
  min-width: 50px;
  margin-right: 10px;
  ${iconBoxOnMobile};
`;

export const DropdownContentWrapper = styled.div`
  padding: 10px 0;
`;

const itemHoverStyles = css<ItemProps>`
  background: ${({ isPlaceholder }) =>
    isPlaceholder ? 'none' : 'rgba(9, 188, 228, 0.1)'};
  & > div:first-child > div {
    background: #d2eef6;
  }
  img {
    filter: invert(77%) sepia(177%) saturate(2269%) hue-rotate(172deg)
      brightness(151%) contrast(68%);
    opacity: 0.3;
  }
`;

const itemSelectedStyles = css<ItemProps>`
  background: ${({ isPlaceholder }) => (isPlaceholder ? 'none' : '#F5F7FA')};
`;

const placeholderStyles = css`
  padding: 0 0 0 10px;
  img {
    margin-left: -10px;
  }
  & > div:first-child > div {
    max-height: 45px;
  }
`;

export const DropdownItemWrapper = styled.div<ItemProps>`
  ${flexRow};
  cursor: pointer;
  padding: 0 10px;
  min-height: 60px;
  align-items: center;
  ${({ isSelected, isPlaceholder }) =>
    isSelected && !isPlaceholder && itemSelectedStyles};
  ${({ isPlaceholder }) => isPlaceholder && placeholderStyles}
  &:hover {
    ${({ isPlaceholder }) => !isPlaceholder && itemHoverStyles}
  }
`;

const formatsWrapperOnMobile = media.phone`
  min-width: 73px;
  margin-left: 10px;
  & > div {
    &:after {
      margin: 0 auto 0 0;
    }
  }
  ${DropdownItemWrapper} {
    max-width: 56px;
    padding-left: 7px;
  }
`;

export const FormatsWrapper = styled.div<{ isOpenDropdown: boolean }>`
  z-index: 3;
  background: #fff;
  min-width: 250px;
  max-height: 50px;
  margin-left: 20px;
  border-radius: 5px;
  position: relative;
  box-shadow: 0px 2px 10px rgba(1, 83, 130, 0.1);

  & > div {
    & > div {
      flex: 1 1;
    }
    &:after {
      margin-right: 9px;
      filter: brightness(24%) contrast(90%);
    }
  }

  ${DropdownContent} {
    top: 60px;
    min-width: 100%;
    &:before,
    &:after {
      border: none;
    }
  }

  &:hover {
    & > div > div:last-child {
      pointer-events: ${({ isOpenDropdown }) =>
        isOpenDropdown ? 'all' : 'none'};
    }
  }
  ${formatsWrapperOnMobile};
`;
